// extracted by mini-css-extract-plugin
module.exports = {"popover":"AddToTeam_popover__igMCv","form":"AddToTeam_form__5Hlro","nameFields":"AddToTeam_nameFields__3a8GV","button":"AddToTeam_button__qsGY1"};